<template>
    <div>
        <v-dialog 
            v-model="display"
            persistent
            width="500">
            <v-card flat>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.date"
                                :rules="rules.date"
                                :disabled="uneditableField('date')"
                                :label="$t('date')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.date" @input="menu = false" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                        <v-text-field
                            autofocus
                            :append-icon="form.customer_id ? '' : 'mdi-magnify'"
                            :readonly="!!form.customer_id"
                            :clearable="true"
                            @click:clear="form.customer_id = null"
                            @keypress.enter="openCustomerSearchDialog"
                            @blur="!form.customer_id ? form.customer = null : null"
                            v-model="form.customer"
                            :rules="rules.customer_id"
                            :disabled="uneditableField('customer')"
                            :label="$t('customer')">
                        </v-text-field>
                        <v-text-field
                            v-model="form.amount_formated"
                            :rules="rules.amount"
                            :disabled="uneditableField('amount')"
                            @change="formatAccounting('amount', 'SDG')"
                            :label="$t('amount')">
                        </v-text-field>
                        <v-textarea
                            :label="$t('note')"
                            v-model="form.notes"
                            :disabled="uneditableField('notes')"
                            :rules="rules.notes">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit" :loading="loading.submit"  :disabled="!valid " text>
                        {{ $t('save_btn') }}
                    </v-btn>
                    <v-btn @click="display = false" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <CustomerSearchDialog
            @store="fetchCustomerName"
            ref="customerSearchDialog"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import {mapActions, mapState} from 'vuex';
import uneditableField from '@/utils/uneditableField';
import RetryDialog from '@/components/common/RetryDialog';
import CustomerSearchDialog from '@/components/Sales/CustomerSearchDialog';
import AlertDialog from '@/components/common/AlertDialog';
import formatAccounting from '../../utils/formatAccounting';

export default {
    name: "debitNotessDialog",
    props: {
        id: Number,
        value: Boolean
    },
    components: {
        RetryDialog,
        CustomerSearchDialog,
        AlertDialog
    },
    data() {
        return {
            valid: false,
            openParams: null,
            menu: false,
            mode: {
                edit: false
            },
            loading: {
                data: true,
                submit: false
            },
            form : {
                id: null,
                date: new Date().toISOString().substr(0, 10),
                customer: null,
                customer_id: null,
                amount: null,
                base_amount: null,
                amount_formated: null,
                notes: null,
            },
            rules: {
                date: [
                    v => !!v || this.$t('rules_required')
                ],
                customer_id: [
                    v => !!v || this.$t('rules_required')
                ],
                amount: [
                    v => !!v || this.$t('rules_required')
                ],
                notes: [
                    v => !!v || this.$t('rules_required')
                ]
            }  
        }
    },
    computed: {
        editMode() {
            return this.id != null;
        },
        notEditMode() {    
            return !this.editMode;
        },
        title(){
            if(this.notEditMode) return this.$t('new_debit')
            else return this.$t('edit_debit')
        },
        display: {
            get() {
                return this.value;
            },
            set(val) {
                return this.$emit("input", val);
            }
        },
        ...mapState('sales/debitNotes', ["debitNote"]) 
    },
    methods: {
        formatAccounting,
        uneditableField,
        ...mapActions('sales/debitNotes', ["fetchDebitNotess", "fetchDebitNote", "storeDebitNote", "updateDebitNote"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions("sales/dpk", ["fetchDpk"]),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        async openDataFetch() {
            try {
                this.loading.data = true;
                if(this.editMode) {
                    await this.fetchDebitNote(this.id);
                    this.form = JSON.parse(JSON.stringify(this.debitNote));
                } else this.getDpkData();
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"openDataFetch",message});
            }
        },
        openCustomerSearchDialog() {
            this.$refs.customerSearchDialog.open(this.form.customer);
        },
        fetchCustomerName(params) {
            this.form.customer_id =params.id;
            this.form.customer = params.name;
        },
        submit() {
            this.loading.submit = true;
            // // TODO: [!] Temporary line to match the base amount the given amount until implementing multi currency if required.
            // this.form.base_amount = this.form.amount;
            if(this.notEditMode) {
                this.storeDebitNote(this.form)
                    .then(() => {
                        this.$emit("updated");
                        this.display = false;
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: "error", message});
                    })
            } else {
                this.updateDebitNote(this.form)
                    .then(() => {
                        this.$emit("updated");
                        this.display = false;
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.display = false;
            }
        },
        resetField() {
            this.form.customer_id = null;
            this.form.customer = null;
        }
    },
    created() {
        this.openDataFetch();
    }

}
</script>